import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./Invoice.css";
import Logo from "../assets/app-assets/images/logo/LOGO-01.png";
import { AppUtils } from "../services/AppUtils";
import { QRCodeSVG } from "qrcode.react";

const VVInvoice = () => {
  const location = useLocation();

  const [invoices, setInvoices] = useState(null);

  useEffect(() => {
    setInvoices(location.state.data);
  }, []);

  return (
    <React.Fragment>
      {invoices &&
        invoices.map((data) => (
          <div style={{ pageBreakBefore: "always" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", margin: "10px" }}>
              <img
                style={{ width: "180px", padding: "15px 15px", float: "left" }}
                src={Logo}
                alt=""
              />
              <h1 style={{ textAlign: "center", marginRight: "180px" }}>Tax Invoice</h1>
              <div style={{ display: "flex", gap: "20px" }}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                  {/* <img
                    src={data?.qrcode}
                    alt="QR Code"
                    style={{ width: "100px", height: "100px" }}
                  />
                  <span>QR Code</span> */}
                </div>
              </div>
            </div>
            <table className="invoice-template-table">
              <tbody>
                <tr>
                  <th rowSpan="2" colSpan="2">
                    <div>
                      {data?.warehouse?.name} <br />
                      {data?.warehouse?.address_line1} <br />
                      {data?.warehouse?.address_line2} <br />
                      <strong>GSTIN/UIN : </strong>
                      {data?.warehouse?.gstin}
                      <br />
                      <strong>State Name : </strong>
                      {data?.warehouse?.state_name} <br />
                      <strong>Code : </strong>
                      {data?.warehouse?.gst_state_code}
                      <br />
                      <strong>CIN : </strong>
                      {data?.warehouse?.cin} <br />
                      <strong>Phone : </strong>
                      {data?.warehouse?.phone}
                      <br />
                      <strong>Website : </strong>www.indusviva.com
                    </div>
                  </th>
                  <th colSpan="3">
                    <strong>Invoice No: </strong> <br />
                    <span className="table-invoice-no">{data?.invoice_no}</span>
                  </th>
                  <th colSpan="2">
                    <strong>Invoice Date: </strong> <br />
                    {AppUtils.formatDateTime(data?.invoice_date)}
                  </th>
                  <td colspan="6" rowspan="2">
                    Dispatch through : <strong>{data?.courier_name}</strong>
                    <br />
                    Dispatch Doc no : <strong>{data?.docket_no}</strong>
                    <br />
                    Dispatch Date : <strong>{AppUtils.formatDateTime(data?.dispatched_on)}</strong>
                    <br />
                    Destination : <strong>{data?.destination}</strong>
                  </td>
                </tr>
                <tr>
                  <th colSpan="3">
                    <strong>Mode of payment</strong> <br />
                    {data?.modeofpay} <br />
                    <strong>Bank Generated Number: </strong> <br />
                    {data?.bank_ref_no}
                    <br />
                  </th>
                  <th colSpan="2">
                    <strong>Order No:</strong> <br />
                    {data?.order_no}
                  </th>
                </tr>
                <tr>
                  <td colSpan="5">
                    <strong> Consignee (Ship To)</strong> <br />
                    <br />
                    Name : <strong>{data?.ship_to?.direct_seller_name}</strong>
                    <br />
                    Address :{" "}
                    <strong>
                      {data?.ship_to?.shipping_address_line1}, {data?.ship_to?.shipping_address_line2},{" "}
                      {data?.ship_to?.shipping_city}
                    </strong>
                    <br />
                    State Name : <strong>{data?.ship_to?.shipping_state}</strong> <br />
                    Postalcode :<strong>{data?.ship_to?.shipping_postalcode}</strong>
                    <br />
                    Phone : <strong>{data?.ship_to?.shipping_contact}</strong>
                    <br />
                  </td>
                  <td colSpan="4">
                    <strong>Buyer (Bill TO)</strong>
                    <br />
                    <br />
                    Name : {data?.distributor_name}
                    <br />
                    Address :{data?.address?.address_line1}, {data?.address?.address_line2}, {data?.address?.city_name},
                    <br />
                    State Name : {data?.address?.state_name} <br />
                    Postalcode :{data?.address?.postalcode}
                    <br />
                    Phone : {data?.address?.phone}
                    <br />
                    GSTIN : {data?.distributor_gst_no}
                    <br />
                    Direct Seller ID : <strong>{data?.distributor_id}</strong>
                    <br />
                  </td>
                </tr>
                <tr>
                  <td colSpan="1">SL NO</td>
                  <td colSpan="1">Description</td>
                  <td className="text-center" colSpan="1">
                    HSN / SAC
                  </td>
                  <td className="text-center" colSpan="1">
                    GST Rate
                  </td>
                  <td className="text-center" colSpan="1">
                    Quantity
                  </td>
                  <td className="text-center" colSpan="1">
                    UOM
                  </td>
                  <td className="text-center" colSpan="1">
                    Unit Price
                  </td>
                  <td className="text-center" colSpan="1">
                    Tax Amount
                  </td>
                  <td className="text-center" colSpan="1">
                    Amount
                  </td>
                </tr>
                {data?.order_items &&
                  data?.order_items?.map((product, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td className="text-bold">{product?.vvp_productname}</td>
                      <td className="text-center">{product?.vvp_hsncode}</td>
                      <td className="text-center">{product?.vvp_gst_percent}%</td>
                      <td className="text-center text-bold">{product?.vvoi_quantity}</td>
                      <td className="text-center">NOS</td>
                      <td className="text-right">{Number(product?.vvoi_base_amount).toFixed(2)}</td>
                      <td className="text-right">{Number(product?.item_total_discount ?? 0).toFixed(2)}</td>
                      <td className="text-right">{Number(product?.vvoi_gross_amount).toFixed(2)}</td>
                    </tr>
                  ))}
                <tr>
                  <td></td>
                  <td colSpan={"2"}>
                    Total Before Tax &amp; Discount
                    <br />
                    {data?.tax_method} TAX Round Of
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="text-right">
                    {Number(data?.total_before_tax).toFixed(2)}
                    <br />
                    {Number(data?.total_tax).toFixed(2)}
                    <br />
                  </td>
                </tr>
                <tr>
                  <td colSpan="8">Total Amount</td>
                  <td className="text-right text-bold">{Number(data?.total_price).toFixed(2)}</td>
                </tr>
                <tr>
                  <td colSpan="9">
                    Amount in Words : <strong style={{ textTransform: "capitalize" }}> {data?.total_amount_in_words} only</strong>
                  </td>
                </tr>
                <tr>
                  <td rowSpan="2">
                    <strong>HSN / SAC</strong>
                  </td>
                  <td rowSpan="2">
                    <strong>Taxable Value</strong>
                  </td>
                  <td className="text-center" colSpan="2">
                    <strong>Central Tax</strong>
                  </td>
                  <td className="text-center" colSpan="2">
                    <strong>State Tax</strong>
                  </td>
                  <td className="text-center" colSpan="2">
                    <strong>Integrated Tax</strong>
                  </td>
                  <td className="text-center" rowSpan="2">
                    <strong>Total Tax Amount</strong>
                  </td>
                </tr>
                <tr>
                  <td className="text-center">Rate</td>
                  <td className="text-center">Amount</td>
                  <td className="text-center">Rate</td>
                  <td className="text-center">Amount</td>
                  <td className="text-center">Rate</td>
                  <td className="text-center">Amount</td>
                </tr>
                {data?.order_items &&
                  data?.order_items?.map((product) => (
                    <tr>
                      <td>-</td>
                      <td>{Number(product?.vvoi_base_amount).toFixed(2)}</td>
                      <td className="text-center">{product?.vvoi_tax_cgst_percentage}%</td>
                      <td className="text-right">{product?.vvoi_tax_cgst_amount}</td>
                      <td className="text-center">{product?.vvoi_tax_sgst_percentage}%</td>
                      <td className="text-right">{product?.vvoi_tax_sgst_amount}</td>
                      <td className="text-center">{product?.vvoi_tax_igst_percentage}%</td>
                      <td className="text-right">{product?.vvoi_tax_igst_amount}</td>
                      <td className="text-right">{Number(product?.vvoi_total_tax_amount).toFixed(2)}</td>
                    </tr>
                  ))}
                <tr>
                  <td>Total</td>
                  <td>{Number(data?.total_price - data?.total_tax).toFixed(2)}</td>
                  <td colSpan="2" className="text-right">
                    {data?.total_cgst}
                  </td>
                  <td colSpan="2" className="text-right">
                    {data?.total_sgst}
                  </td>
                  <td colSpan="2" className="text-right">
                    {data?.total_igst}
                  </td>
                  <td className="text-right">{Number(data?.total_tax).toFixed(2)}</td>
                </tr>
                <tr>
                  <td colSpan="9">
                    Tax Amount (in words) :<strong style={{ textTransform: "capitalize" }}>{data?.total_tax_in_words} Only</strong>
                  </td>
                </tr>
                <tr>
                  <td colSpan="9">
                    {data?.irn && (
                      <>
                        IRN number : <strong>{data?.irn}</strong>
                      </>
                    )}

                  </td>

                </tr>
                {data?.total_amount > 50000 && data?.qrcode && (
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <QRCodeSVG value={data?.qrcode} size={256} level="M" includeMargin={true} />
                    <span>E-Invoice</span>
                  </div>
                )}
                <th colspan="9" style={{ textAlign: "right" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      flexWrap: "wrap",
                      alignContent: "flex-end",
                    }}
                  >
                    <span>For IndusViva HealthSciences Private Limited,</span>
                    <img src={data?.warehouse?.signature_url} alt="" style={{ width: "160px", padding: "15px" }} />
                    <span>Authorized Signatory</span>
                  </div>
                </th>
                <tr>
                  <th colSpan="9" style={{ textAlign: "center", fontSize: "11px" }}>
                    Subject to {data?.warehouse?.jurisdiction} jurisdiction <br />
                    Computer Generated Invoice, Does Not Require Signature.
                    <br />
                    Difference if any should be reported within 24 hours from receipt of this Tax Invoice.
                    <br />
                    {data?.warehouse?.address_line1}, {data?.warehouse?.address_line2}
                    <br />
                  </th>
                </tr>
              </tbody>
            </table>
            <span>
              {data?.serialnumber} of {invoices?.length}
            </span>
          </div>
        ))}
    </React.Fragment>
  );
};

export default VVInvoice;
